/**
 * Hindi for the cash book supervisor screens (V1_SPEC section 12, UX_COPY terms table). Keys are the
 * English text. Merged into HI at the end of i18n/hi.ts; a key that HI already has with another
 * meaning is left out here (cashbookI18n.test.ts checks), so other Karkhana screens never change.
 * Never on supervisor screens: "पुष्टि", "लागू", "मंज़ूर", "रास्ते में", audit words.
 */
export const HI_CASHBOOK_SUPERVISOR: Record<string, string> = {
  Cash: "नकद",
  "Cash in hand": "हाथ में नकद",
  "Carried from yesterday {{amount}}": "कल का {{amount}}",
  "received today {{amount}}": "आज मिला {{amount}}",
  "received from others {{amount}}": "दूसरों से मिला {{amount}}",
  "paid today {{amount}}": "आज दिया {{amount}}",
  "spent {{amount}}": "खर्च {{amount}}",
  "handed to others {{amount}}": "दूसरों को दिया {{amount}}",
  "given back {{amount}}": "लौटाया {{amount}}",
  'Coming: {{amount}} (from {{name}}, adds when you tap "Received")': 'आने वाला: {{amount}} ({{name}} से, आपके "मिल गए" दबाने पर जुड़ेगा)',
  "Print the sheet": "पत्रक छापें",
  "Pay and get signatures": "भुगतान करें, हस्ताक्षर लें",
  "Send a photo in the evening": "शाम को फ़ोटो भेजें",
  "Print pay sheet": "भुगतान पत्रक छापें",
  "Send pay sheet photo": "भुगतान पत्रक की फ़ोटो भेजें",
  "Send spends page photo": "खर्च के पन्ने की फ़ोटो भेजें",
  "Today's photos sent": "आज की फ़ोटो भेज दी ✓",
  "Hand cash to…": "नकद दें…",
  "Give cash back": "नकद लौटाएँ",
  "Type a spend": "खर्च लिखें",
  "Sent ✓": "भेजा ✓",
  "Checked ✓": "जाँच हुई ✓",
  "{{n}} people": "{{n}} लोग",
  "Pages {{pages}} not sent": "पन्ने {{pages}} बाकी",
  "Today's pay sheet isn't sent yet. Send a photo when you finish.": "आज का भुगतान पत्रक अभी नहीं भेजा। काम ख़त्म होने पर फ़ोटो भेजें।",
  "Yesterday's pay sheet isn't sent yet. Send the photo now.": "कल का भुगतान पत्रक अभी नहीं भेजा। अभी फ़ोटो भेजें।",
  "Today's spends page isn't sent yet. Send a photo when you finish.": "आज के खर्च के पन्ने की फ़ोटो अभी नहीं भेजी। काम ख़त्म होने पर फ़ोटो भेजें।",
  "Pay sheet to send · Cash": "आज का भुगतान पत्रक भेजना बाकी · नकद",
  "Spends page to send · Cash": "खर्च के पन्ने की फ़ोटो भेजना बाकी · नकद",
  "Photos keep your account clear. If something is wrong you can ask for a change.": "फ़ोटो से आपका हिसाब साफ़ रहता है। ग़लती हो तो बदलाव माँग सकते हैं।",
  "Couldn't print? Write the sheet number on top and send a photo of the handwritten page.":
    "छाप नहीं पाए? पत्रक नंबर ऊपर लिखकर हाथ से लिखे पन्ने की फ़ोटो भेजें।",
  "Saved on phone · {{n}} photos send when the network is back": "फ़ोन में सेव · {{n}} फ़ोटो नेटवर्क आते ही जाएँगी",
  "I am not {{name}}": "मैं {{name}} नहीं हूँ",
  "Keep the whole sheet in the frame, all four corners showing.": "पूरा पत्रक फ़्रेम में रखें। चारों कोने दिखें।",
  Torch: "टॉर्च",
  "Take photo": "फ़ोटो लें",
  "Choose from phone": "फ़ोन से चुनें",
  "Sheet {{sheetNo}} · page {{page}} / {{pages}} found": "पत्रक {{sheetNo}} · पन्ना {{page}} / {{pages}} मिला",
  "{{n}} pages left": "{{n}} पन्ने बाकी",
  "Next page ({{page}}/{{pages}})": "अगला पन्ना ({{page}}/{{pages}})",
  Send: "भेजें",
  "Send anyway": "फिर भी भेजें",
  "Total paid written on the sheet": "पत्रक पर लिखा कुल दिया",
  "Total written on the page": "पन्ने पर लिखा कुल",
  "Photo is blurry; amounts won't be readable.": "फ़ोटो धुंधली है, रकम पढ़ी नहीं जाएगी।",
  Retake: "फिर से लें",
  "The owner may not read the amounts and may ask again tomorrow.": "मालिक रकम नहीं पढ़ पाएँगे, कल फिर माँग सकते हैं।",
  "Turn on the torch and take it from above with the sheet on the floor.": "टॉर्च जलाएँ, पत्रक ज़मीन पर रखकर ऊपर से लें।",
  "Which sheet is this?": "यह कौन सा पत्रक है?",
  "Which page?": "कौन सा पन्ना?",
  "Page {{page}}": "पन्ना {{page}}",
  "No printed sheets in the last 14 days. Print the pay sheet first.": "पिछले 14 दिन में कोई छपा पत्रक नहीं। पहले भुगतान पत्रक छापें।",
  "Already sent at {{time}}. The new photo is added; the old one stays.": "यह पन्ना {{time}} पर भेजा जा चुका है। नई फ़ोटो साथ में जुड़ेगी, पुरानी रहेगी।",
  "Add page": "पन्ना जोड़ें",
  "Don't add": "रहने दें",
  "This is Print {{old}}, but Print {{new}} exists. Send the photo of Print {{new}}.": "यह प्रिंट {{old}} है, पर प्रिंट {{new}} बन चुका है। प्रिंट {{new}} की फ़ोटो भेजें।",
  "This photo was already sent at {{time}}.": "यह फ़ोटो {{time}} पर भेजी जा चुकी है।",
  "The photo is too big. Take it again.": "फ़ोटो बहुत बड़ी है। फिर से लें।",
  "The photo didn't upload. Try again.": "फ़ोटो नहीं गई। फिर से कोशिश करें।",
  "Photo storage isn't set up yet. Ask HKP support.": "फ़ोटो रखने की जगह अभी तैयार नहीं। HKP सहायता से पूछें।",
  "Spends page · {{date}}": "खर्च का पन्ना · {{date}}",
  "Pages {{pages}} will stay unsent": "पन्ने {{pages}} बाकी रहेंगे",
  "Sent ✓ · {{sheetNo}}": "भेजा ✓ · {{sheetNo}}",
  "Photo sent ✓": "फ़ोटो भेजी ✓",
  Amount: "रकम",
  "What for?": "किस पर?",
  Search: "खोजें",
  "Paid to (optional)": "किसे दिया (ज़रूरी नहीं)",
  "For what work? (optional)": "किस काम के लिए? (ज़रूरी नहीं)",
  "Bill photo (optional)": "बिल की फ़ोटो (ज़रूरी नहीं)",
  "Bill photo added ✓": "बिल की फ़ोटो जुड़ी ✓",
  "Save {{amount}} spend": "{{amount}} खर्च सेव करें",
  "Spend saved · Cash in hand {{amount}}": "खर्च सेव हुआ · हाथ में नकद {{amount}}",
  "You seem to have only {{amount}}": "आपके पास {{amount}} ही दिख रहे हैं",
  "Choose a spend type.": "खर्च का प्रकार चुनें।",
  "Type the amount.": "रकम लिखें।",
  "Request change": "बदलाव माँगें",
  "Correct amount": "सही रकम",
  "Why?": "क्यों?",
  "Wrote wrong": "ग़लत लिखा",
  "Didn't pay in full": "पूरा नहीं दिया",
  "Written twice": "दो बार लिखा",
  "Was someone else's": "दूसरे का था",
  "Something else": "कुछ और",
  "Say what happened": "बताएँ क्या हुआ",
  "Send change": "बदलाव भेजें",
  "{{old}} counts until the owner says yes. Then your cash in hand goes up by {{diff}}.":
    "{{old}} ही गिना जाएगा जब तक मालिक हाँ न कहें। हाँ होने पर आपके हाथ में नकद {{diff}} बढ़ जाएगा।",
  "{{old}} counts until the owner says yes. Then your cash in hand goes down by {{diff}}.":
    "{{old}} ही गिना जाएगा जब तक मालिक हाँ न कहें। हाँ होने पर आपके हाथ में नकद {{diff}} घट जाएगा।",
  "{{old}} counts until the owner says yes.": "{{old}} ही गिना जाएगा जब तक मालिक हाँ न कहें।",
  Correct: "सुधारें",
  "Every correction stays in the record.": "हर सुधार रिकॉर्ड में रहता है।",
  "Change asked": "बदलाव माँगा",
  "Corrected ✓": "सुधार हो गया ✓",
  "No network. Nothing changed; tap again.": "नेटवर्क नहीं है। कुछ नहीं बदला, फिर से दबाएँ।",
  "No network. Tap Save again; it won't be saved twice.": "नेटवर्क नहीं है। फिर से सेव दबाएँ, दो बार नहीं जुड़ेगा।",
  "Photo not sent: {{what}}": "फ़ोटो नहीं गई: {{what}}",
  "Pay sheet photo · {{date}}": "भुगतान पत्रक की फ़ोटो · {{date}}",
  "Printed already (Print {{n}}). Print again? The new print replaces the old one.": "छपा हुआ है (प्रिंट {{n}})। फिर से छापें? नया प्रिंट पुराने की जगह लेगा।",
  "Print again": "फिर से छापें",
  "Send photo": "फ़ोटो भेजें",
  Print: "छापें",
  "Print {{n}}": "प्रिंट {{n}}",
  "Everyone on this sheet is paid. Nothing to print.": "इस पत्रक पर सबको भुगतान हो चुका। छापने को कुछ नहीं।",
  "Someone changed this just now. Refresh and try again.": "अभी किसी ने इसे बदला। फिर से खोलकर कोशिश करें।",
  "A change is already waiting for this.": "इसके लिए एक बदलाव पहले से माँगा हुआ है।",
  "This is checked. Ask for a change instead.": "इसकी जाँच हो चुकी। बदलाव माँगें।",
  "Not saved. Check the network and retry.": "सेव नहीं हुआ। नेटवर्क देखें और फिर से कोशिश करें।",
  Retry: "फिर से कोशिश करें",
  "Paid to {{name}}": "{{name}} को दिया",
  "From {{sheetNo}}": "{{sheetNo}} से",
  "What happened": "क्या हुआ",
  "{{amount}} written by {{name}}": "{{amount}} {{name}} ने लिखा",
  "{{amount}} from the photo": "{{amount}} फ़ोटो से",
  "Checked by {{name}}": "{{name}} ने जाँच की",
  "Changed {{before}} → {{after}}": "{{before}} से {{after}} किया",
  "Change asked: {{before}} → {{after}}": "बदलाव माँगा: {{before}} से {{after}}",
  "Change asked: remove this": "बदलाव माँगा: इसे हटाएँ",
  "Owner said yes: {{after}}": "मालिक ने हाँ कहा: {{after}}",
  "Owner kept {{before}}": "मालिक ने {{before}} ही रखा",
  "Sheet printed": "पत्रक छपा",
  "Photo sent": "फ़ोटो भेजी",
  "Recent": "हाल के",
  "Spend": "खर्च",
  "Cash given to you": "आपको नकद मिला",
  "Advance": "एडवांस",
  "Remove": "हटाएँ",
  "Couldn't load. Check the network.": "लोड नहीं हुआ। नेटवर्क देखें।",
  "Save {{amount}}": "{{amount}} सेव करें",
  "Cash given back · Cash in hand {{amount}}": "नकद लौटाया · हाथ में नकद {{amount}}",
  "Pay sheets to print": "छापने के पत्रक",
  "Pay sheet photo sent ✓ · Pages {{pages}} not sent": "पत्रक की फ़ोटो भेजी ✓ · पन्ने {{pages}} बाकी",
  "Opening the camera…": "कैमरा खुल रहा है…",
  "The camera didn't open. Choose a photo from the phone instead.": "कैमरा नहीं खुला। फ़ोन से फ़ोटो चुनें।",
  "Checking the photo…": "फ़ोटो देख रहे हैं…",
  "Sending…": "भेज रहे हैं…",
  "Saving…": "सेव हो रहा है…",
  "Backspace": "मिटाएँ",
  "Change pending": "बदलाव माँगा हुआ",
  "{{n}} to do": "{{n}} काम बाकी",
  "Not printed": "नहीं छपा",
  Camera: "कैमरा",
  Pages: "पन्ने",
  "This page was already sent. The new photo is added; the old one stays.": "यह पन्ना पहले भेजा जा चुका है। नई फ़ोटो साथ में जुड़ेगी, पुरानी रहेगी।",
  "Printing…": "छप रहा है…",
  "This print was replaced by a newer one. Pay only from the newest print.": "इसकी जगह नया प्रिंट बन चुका है। सिर्फ़ नए प्रिंट से भुगतान करें।",
  "Who pays from this sheet?": "इस पत्रक से कौन भुगतान करेगा?",
  "The supervisor who pays sends the photo in the evening. Cash paid from it comes off their cash in hand.":
    "जो सुपरवाइज़र भुगतान करेगा, वही शाम को फ़ोटो भेजेगा। इससे दिया नकद उसके हाथ के नकद से घटेगा।",
  "Office (I pay)": "ऑफ़िस (मैं भुगतान करूँगा)",
  "Not from a supervisor's cash": "किसी सुपरवाइज़र के नकद से नहीं",
  // Transfers (FE-2 renders them)
  "To whom?": "किसे?",
  "Give {{amount}} to {{name}}": "{{amount}} {{name}} को दें",
  'Waiting for {{name}} to tap "Received" · {{amount}} not counted for anyone yet': '{{name}} के "मिल गए" दबाने का इंतज़ार · {{amount}} अभी किसी के नाम नहीं',
  "{{name}} gave you {{amount}}": "{{name}} ने {{amount}} दिए",
  'Count, then tap. It adds to your cash in hand only when you tap "Received".': 'गिनकर दबाएँ। "मिल गए" दबाने पर ही आपके हाथ में नकद में जुड़ेगा।',
  Received: "मिल गए",
  "Something's wrong": "ग़लत है",
  "What's wrong?": "क्या ग़लत है?",
  "Got less": "रकम कम मिली",
  "How much did you get?": "कितने मिले?",
  "Didn't get it": "मिले ही नहीं",
  "Tell {{name}}": "{{name}} को बताएँ",
  "You said: only {{amount}} came. {{full}} was not added to you. {{name}} will correct it. Keep this money apart till then.":
    "आपने बताया: {{amount}} ही मिले। {{full}} आपके खाते में नहीं जुड़े। {{name}} ठीक करेंगे। तब तक ये पैसे अलग रखें।",
  "{{amount}} added · Cash in hand {{total}}": "{{amount}} जुड़ गए · हाथ में नकद {{total}}",
  '{{name}} said no: "{{note}}"': '{{name}} ने मना किया: "{{note}}"',
  "In the app {{amount}} is back with you. Write again what you really gave.": "ऐप में {{amount}} वापस आपके नाम। असल में जो दिया, वह फिर से लिखें।",
  "Give {{amount}} again": "{{amount}} फिर से दें",
  "Give again": "फिर से दें",
  "I gave {{amount}} - tell the owner": "मैंने {{amount}} दिए थे - मालिक को बताएँ",
  "Owner told": "मालिक को बताया",
  // FE-2: transfer screens
  "No other supervisor yet.": "अभी कोई और सुपरवाइज़र नहीं है।",
  "Cash in hand {{amount}}": "हाथ में नकद {{amount}}",
  "Only {{amount}} came": "{{amount}} ही मिले",
  "You said it is wrong. {{full}} was not added to you. {{name}} will correct it.": "आपने बताया कि ग़लत है। {{full}} आपके खाते में नहीं जुड़े। {{name}} ठीक करेंगे।",
  "That is not less than {{amount}}.": "यह {{amount}} से कम नहीं है।",
  "Before {{before}} + received {{amount}}": "पहले {{before}} + मिला {{amount}}",
  "I gave {{amount}}": "मैंने {{amount}} दिए थे",
  "Handover": "नकद देना",
  "{{name}} said received · {{when}}": "{{name}} ने मिल गए दबाया · {{when}}",
  "Given again: {{amount}}": "फिर से दिए: {{amount}}",
  "This corrects an earlier handover": "यह पहले वाले लेन-देन को ठीक करता है",
};
